/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import OutputList from "../OutputList/OutputList.jsx";
import OutputListItem from "../OutputList/OutputListItem.jsx";
import {Util} from "../../Utilities.js";
import {Nodes} from "../../Objects/Nodes.jsx";
import Select from "../BasicInputs/Select.jsx";
import DateTime from "toolbox/dateTime";

class NodeSettings extends Component {
    constructor() {
        super();

        this.state = {
            nodeInfo: {}
        }
        this.DebouncedSave = Util.performance.debounce((handler, query) => handler(query), 300)

    }


    async fetchData() {
        let {nodeId} = this.props
        let nodeInfo = await Nodes(nodeId).getInfo()
        this.setState({nodeInfo: nodeInfo ?? {}})

    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.nodeId !== this.props.nodeId) {
            this.fetchData()
        }
    }

    onChange(key, value) {
        let {nodeInfo} = this.state

        this.setState((state) => {
            let newData = state.nodeInfo
            newData[key] = value
            return ({nodeInfo: newData})
        }, () => {
            this.DebouncedSave(() => {
                Nodes(nodeInfo.indexKey).update({[key]: this.state.nodeInfo?.[key]})
            })

        })


    }


    render() {
        let {nodeInfo} = this.state
        return (<div>

            <OutputList>
                <OutputListItem titel={"Node Id"}>
                    <span>{nodeInfo.indexKey}</span>
                </OutputListItem>
                <OutputListItem titel={"Node Name"}>
                    <span>{nodeInfo.nodeName}</span>
                </OutputListItem>
                <OutputListItem titel={"IP-Address"}>
                    <span>{nodeInfo.nodeIP}</span>
                </OutputListItem>
                <OutputListItem titel={"Server Id"}>
                    <span>{nodeInfo.serverId}</span>
                </OutputListItem>
                <OutputListItem titel={"Domain"}>
                    <span>{nodeInfo.nodeDomain}</span>
                </OutputListItem>
                <OutputListItem titel={"SV"}>
                    <span>{nodeInfo.SV}</span>
                </OutputListItem>
                <OutputListItem titel={"Region"}>
                    <span>{nodeInfo.region}</span>
                </OutputListItem>
                <OutputListItem titel={"creationTime"}>
                    <span>{DateTime.format(nodeInfo.creationTime, "HH:mm dd.MM.yyyy")}</span>
                </OutputListItem>
                <OutputListItem titel={"phase"}>
                    <span>{nodeInfo.phase}</span>
                </OutputListItem>
                <OutputListItem titel={"phaseEnteredAt"}>
                    <span>{DateTime.format(nodeInfo.phaseEnteredAt, "HH:mm dd.MM.yyyy")}</span>
                </OutputListItem>
                <OutputListItem titel={"capacity"}>
                    <span>{nodeInfo?.capacity?.cores}x Cores {nodeInfo?.capacity?.ram}Gb Ram</span>
                </OutputListItem>
                <OutputListItem titel={"Auto Fix"}>
                            <span>
                                <Select
                                    options={[{value: "auto", label: "auto", iconName: "PiMagicWand"}, {
                                        value: "manuel",
                                        label: "manuel",
                                        iconName: "PiHandPointing"
                                    }, {value: "locked", label: "locked", iconName: "PiLockSimple"},]}
                                    value={{value: nodeInfo?.steeringType ?? "auto"}} onChange={(newValue) => {
                                    this.onChange("steeringType", newValue.value)
                                }}/>

                            </span>
                </OutputListItem>
            </OutputList>

            {/*<OutputList>*/}
            {/*    <OutputListItem titel={"Container Id"}>*/}
            {/*        <span>{containerInfo.indexKey}</span>*/}
            {/*    </OutputListItem>*/}
            {/*    <OutputListItem titel={"Container Name"}>*/}
            {/*        <span>{containerInfo.containerName}</span>*/}
            {/*    </OutputListItem>*/}
            {/*    <OutputListItem titel={"Image Id"}>*/}
            {/*        <span>{containerInfo.imageIndexKey}</span>*/}
            {/*    </OutputListItem>*/}
            {/*    <OutputListItem titel={"Address"}>*/}
            {/*        <span>{containerInfo.domain}</span>*/}
            {/*    </OutputListItem>*/}
            {/*    <OutputListItem titel={"Node Id"}>*/}
            {/*        <span>{containerInfo.nodeIndexKey}</span>*/}
            {/*    </OutputListItem>*/}
            {/*    <OutputListItem titel={"Http Port"}>*/}
            {/*        <span>{containerInfo.httpPort}</span>*/}
            {/*    </OutputListItem>*/}
            {/*    <OutputListItem titel={"Background"}>*/}
            {/*        <span>*/}
            {/*            <TextInput value={(containerInfo?.backgroundURL ?? "").toString()} onChange={(newValue) => {*/}
            {/*                this.onChange("backgroundURL", newValue)*/}
            {/*            }}/>*/}
            {/*        </span>*/}
            {/*    </OutputListItem>*/}
            {/*    <OutputListItem titel={"Exposed Ports"}>*/}
            {/*        <span>{(containerInfo?.exposedPorts ?? []).join(", ")}</span>*/}
            {/*    </OutputListItem>*/}
            {/*    <OutputListItem titel={"Mounts"}>*/}
            {/*                <span>{(containerInfo?.mounts ?? []).map((mount) => {*/}
            {/*                    return (<>*/}
            {/*                        <OutputList>*/}
            {/*                            <OutputListItem titel={"Name"}>*/}
            {/*                                <span>{mount.volumeId}</span>*/}
            {/*                            </OutputListItem>*/}
            {/*                            <OutputListItem titel={"Path in Container"}>*/}
            {/*                                <span>{mount.volumePath}</span>*/}
            {/*                            </OutputListItem>*/}
            {/*                        </OutputList>*/}

            {/*                    </>)*/}

            {/*                })}</span>*/}
            {/*    </OutputListItem>*/}

            {/*</OutputList>*/}


        </div>);
    }
}

NodeSettings.propTypes = {};

NodeSettings.defaultProps = {};


export default NodeSettings;